var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1010)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 8.91106H2.37773V11.0888H0.199951V8.91106ZM8.91106 2.37773H11.0888V6.73328H8.91106V2.37773ZM6.73328 8.91106H11.0888V13.2666H8.91106V11.0888H6.73328V8.91106ZM13.2666 8.91106H15.4444V11.0888H17.6222V8.91106H19.7999V11.0888H17.6222V13.2666H19.7999V17.6222H17.6222V19.7999H15.4444V17.6222H11.0888V19.7999H8.91106V15.4444H13.2666V13.2666H15.4444V11.0888H13.2666V8.91106ZM17.6222 17.6222V13.2666H15.4444V17.6222H17.6222ZM13.2666 0.199951H18.7999C19.3522 0.199951 19.7999 0.647666 19.7999 1.19995V6.73328H13.2666V0.199951ZM15.4444 2.37773V4.55551H17.6222V2.37773H15.4444ZM0.199951 1.19995C0.199951 0.647665 0.647666 0.199951 1.19995 0.199951H6.73328V6.73328H0.199951V1.19995ZM2.37773 2.37773V4.55551H4.55551V2.37773H2.37773ZM0.199951 13.2666H6.73328V19.7999H1.19995C0.647665 19.7999 0.199951 19.3522 0.199951 18.7999V13.2666ZM2.37773 15.4444V17.6222H4.55551V15.4444H2.37773Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.742d2bea.svg";
export { ForwardRef as ReactComponent };